import { render } from "./manualRecord.vue?vue&type=template&id=68e3573b&scoped=true"
import script from "./manualRecord.vue?vue&type=script&lang=js"
export * from "./manualRecord.vue?vue&type=script&lang=js"

import "./manualRecord.vue?vue&type=style&index=0&id=68e3573b&scoped=true&lang=css"

import exportComponent from "D:\\A_Projcets_Code\\mes-chunyu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e3573b"]])

export default __exports__